import { render, staticRenderFns } from "./articoliFornitori.html?vue&type=template&id=20cd35a0&"
import script from "./ArticoliFornitori.vue?vue&type=script&lang=js&"
export * from "./ArticoliFornitori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports